import React, { Component } from 'react'
import i18n from 'i18next'
import * as R from 'ramda'
import { v4 as uuidv4 } from 'uuid'
import { cloneDeep } from 'lodash'
import { observer } from 'mobx-react'

import Button from '../../../../UniformComponents/Button'
import Checkbox from '../../../form/Checkbox'
import Input from '../../../form/Input'
import ExploriDatePicker from '../../../ExploriDatePicker'

@observer
class Date extends Component {
    constructor(props) {
        super(props)

        const {
            store,
            register,
            name,
            path,
        } = props
        const { customTag } = store

        if (typeof register === 'function') {
            register(name, this.validate, path)
        }

        if (R.isNil(customTag.config.dateOptions)) {
            customTag.config.dateOptions = []
        }
    }

    componentWillUnmount() {
        const {
            unregister,
            name,
            path,
        } = this.props

        if (typeof unregister === 'function') {
            unregister(name, path)
        }
    }

    addOption = () => {
        const { store } = this.props
        const { customTag } = store
        const { config } = customTag
        const { dateOptions } = config

        const options = dateOptions.slice()
        options.push({
            uuid: uuidv4(),
            config: {
                langs: {
                    en_GB: '',
                },
                startDate: undefined,
                endDate: undefined,
                repeat: false,
            },
        })

        config.dateOptions = options
    }

    removeOption = (optionId) => {
        const { store } = this.props
        const { customTag } = store
        const { config } = customTag
        const { dateOptions } = config

        const filteredOptions = dateOptions
            .slice()
            .filter(({ uuid }) => uuid !== optionId)

        config.dateOptions = filteredOptions
    }

    onBlur = ({ value, name }, optionId) => {
        const { store } = this.props
        const { customTag } = store
        const { config } = customTag
        const { dateOptions } = config

        const options = dateOptions.slice()

        const optionIndex = options.findIndex(({ uuid }) => uuid === optionId)
        const option = cloneDeep(options[optionIndex])
        if (name === 'label') {
            option.config.langs.en_GB = value
        } else {
            option.config[name] = value
        }
        options.splice(optionIndex, 1, option)

        config.dateOptions = options
    }

    renderOptions = () => {
        const { store } = this.props
        const { customTag } = store
        const { config } = customTag
        const { dateOptions } = config

        return (
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                }}
            >
                <table>
                    <thead>
                        <tr>
                            <th style={{ width: 'auto' }} />
                            <th style={{ width: '190px' }}>{i18n.t('customTag.date.start')}</th>
                            <th style={{ width: '190px' }}>{i18n.t('customTag.date.end')}</th>
                            <th style={{ width: '50px' }}>{i18n.t('customTag.date.repeat')}</th>
                            <th style={{ width: '55px' }} />
                        </tr>
                    </thead>
                    <tbody>
                        {dateOptions.map(({ uuid, config }) => (
                            <tr
                                key={uuid}
                            >
                                <td>
                                    <Input
                                        name="label"
                                        defaultValue={config.langs.en_GB}
                                        onBlur={(obj) => this.onBlur(obj, uuid)}
                                    />
                                </td>
                                <td>
                                    <ExploriDatePicker
                                        name="startDate"
                                        dateOnly
                                        dateTimeText={config.startDate}
                                        dateTimeFormat="DD/MM"
                                        calendarIcon="fal fa-calendar-alt"
                                        placeholder="Day/Month"
                                        onChange={(value) => this.onBlur({ name: 'startDate', value }, uuid)}
                                    />
                                </td>
                                <td>
                                    <ExploriDatePicker
                                        name="endDate"
                                        dateOnly
                                        dateTimeText={config.endDate}
                                        dateTimeFormat="DD/MM"
                                        calendarIcon="fal fa-calendar-alt"
                                        placeholder="Day/Month"
                                        onChange={(value) => this.onBlur({ name: 'endDate', value }, uuid)}
                                    />
                                </td>
                                <td>
                                    <Checkbox
                                        name="repeat"
                                        className="exploriNativeCheckbox"
                                        defaultChecked={config.repeat}
                                        onBlur={(obj) => this.onBlur(obj, uuid)}
                                    />
                                </td>
                                <td>
                                    <i
                                        className="fal fa-trash"
                                        style={{ fontSize: '18px', cursor: 'pointer' }}
                                        onClick={() => this.removeOption(uuid)}
                                    />
                                </td>
                            </tr>
                        ))}
                    </tbody>
                    <tfoot>
                        <tr>
                            <td>
                                <Button
                                    label={i18n.t('customTag.mergefield.addOption')}
                                    onClick={this.addOption}
                                    cssClass="primary secondary"
                                />
                            </td>
                        </tr>
                    </tfoot>
                </table>
            </div>
        )
    }

    validate = () => true

    render() {
        return (
            <fieldset id="dateOptions">
                <legend>{i18n.t('customTag.date.legend')}</legend>
                {this.renderOptions()}
            </fieldset>
        )
    }
}

export default Date
